<template>
    <div class="item" :class="{disable}" @click="$emit('ck')">
        <slot>Class Item</slot>
    </div>
</template>
<script>
export default {
    name: 'ClassItem',
    props: ['disable']
}
</script>
<style lang="less" scoped>
@import 'val.less';
.item {
    height: 55px;
    margin-bottom: 22px;
    font-size: 18px;
    line-height: 55px;
    color: #fff;
    background: @main-color;
    border-radius: 5px;
    box-shadow: 0px 3px 0px @main-color-b;
    cursor: pointer;
    &:active {
        background: @main-color-b;
    }
    &:hover {
        filter: brightness(80%);
    }
    &.disable {
        color: #999999;
        background: #d8d8d8;
        box-shadow: none;
        cursor: auto;
        &:hover {
            filter: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ClassItem.vue